import { closeAll } from "../redux/modalSlice";
import { success } from "../redux/notificationSlice";
import { store } from "../redux/store";

class PWAService {
  db = undefined;
  dbPromise = undefined;

  saveData(request) {
    const requestJson = {
      url: request.baseURL + request.url,
      method: request.method,
      headers: request.headers,
      body: request.data,
    };
    this.dbPromise = indexedDB.open("requests-db", 2);
    this.dbPromise.onupgradeneeded = (event) => {
      this.db = event.target.result;

      // create the Contacts object store
      // with auto-increment id
      if (!this.db.objectStoreNames.contains("requests")) {
        this.db.createObjectStore("requests", { autoIncrement: true });
      }
    };
    this.dbPromise.onsuccess = (e) => {
      this.db = e.target.result;
      var tx = this.db.transaction("requests", "readwrite");
      const stored = tx.objectStore("requests").put(requestJson);
      stored.onsuccess = (ev) => {
        if ("serviceWorker" in navigator) {
          navigator.serviceWorker.ready.then((sw) => {
            sw.sync.register("request-alert").then((event) => {
              store.dispatch(
                success({
                  message:
                    "Request is queued will be sent once network is available",
                })
              );
              store.dispatch(closeAll());
            });
          });
        }
      };
    };
  }
}

const pwaSvc = new PWAService();
export default pwaSvc;
